import { Spin } from 'antd'

export const Spinner = ({ loadingText = 'Loading ...', size = 'large' }) => {
    return (
        <>
            <div className="flex h-full w-full items-center px-8 py-8">
                <div className="w-full text-center">
                    <Spin size={size} />
                    <div className="mt-2 text-13-15 font-bold text-primary-red-500">
                        {loadingText}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Spinner
